<template lang="pug">
v-btn.bg-green.text-white(@click='save' :disabled='disabled' variant='outlined' :type='type')
    span.ml-1
        slot Save
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'ButtonSubmit',
    emits: ['save'],
    props: {
        dataCy: {
            type: String,
            default: undefined,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        type: {
            type: String,
            default: 'submit',
        },
    },
    methods: {
        save() {
            this.$emit('save');
        },
    },
});
</script>
